import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';

import { useSelector } from 'store';
import { Link } from 'components/controls';

import styles from 'theme/components/containers/HomeMessages/HomeMessages.module.scss';

const HomeMessages = () => {
  const { profile } = useSelector((state) => state.auth);

  if (!profile?.additional_information?.length) {
    return null;
  }

  const renderContent = () => {
    return profile?.additional_information?.map((message, i) => {
      const value = Object.values(message);

      return (
        <span key={i}>
          <span dangerouslySetInnerHTML={{ __html: value[0]?.text }} /> -{' '}
          <Link to={`/${value[0]?.url}`} className={styles.item}>
            <Trans>przejdź do płatności</Trans>
          </Link>
        </span>
      );
    });
  };

  return (
    <div
      className={classnames(
        styles.wrapperComponent,
        'StylePath-Components-Containers-HomeMessages'
      )}>
      <div className={styles.content}>{renderContent()}</div>
    </div>
  );
};

export default HomeMessages;
